import { Button } from '@britishcouncil/react-admin';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath, useLocation } from 'react-router';
import { ROUTING_PATHS } from 'const';
import { useIntParam } from 'hooks';

export const Footer = ({ isSaving, formId }: { isSaving: boolean; formId: string }) => {
  const { lrwSessionDetails } = ROUTING_PATHS;
  const sessionId = useIntParam('sessionId');
  const location = useLocation();

  return (
    <Modal.Actions>
      <Link to={generatePath(lrwSessionDetails.absolutePath, { sessionId })} state={location.state}>
        <Button compact type="reset" secondary>
          Cancel
        </Button>
      </Link>

      <Button
        compact
        color="blue"
        type="submit"
        form={formId}
        disabled={isSaving}
        loading={isSaving}
      >
        Save
      </Button>
    </Modal.Actions>
  );
};
